import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class BaseToastService {
  private readonly toastSvc: ToastrService = inject( ToastrService );
  
  public baseAccept( label: string, action: string ){
    this.toastSvc.success( `Registro ${action} correctamente.`, label );
  }

  public baseWait( label: string ){
    this.toastSvc.info( `Descargando archivo solicitado. Por favor, espere.`, label, { positionClass: 'toast-bottom-right' } );
  }

  public baseReject(){
    this.toastSvc.info( 'Ha cancelado la operación.', 'Cancelada' );
  }

  public baseError(){
    this.toastSvc.error( 'Por favor intente más tarde.', 'Error' );
  }
}
